import React from 'react';

import { CoreLink } from '@uncinc/react-drupal-core';

import { Button, Container } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';
import { useTranslation } from 'react-i18next';

const NavigationMainMenuSubComponent = ({ item }) => {
  const { t } = useTranslation();

  const renderMenuRecursively = (newSubTree) => {
    const itemToMap = newSubTree || item;
    return itemToMap.get('subtree').map((subItem, i) => {
      const subItemHref = subItem.getIn(['link', 'url']);
      const subItemTitle = subItem.getIn(['link', 'title'], '');

      if (newSubTree) {
        return (
          <li key={`menu--main--sub-menu-item-${subItemTitle}:${subItemHref}`}>
            <div className={`LegacyNavigationMainMenuDesktop--subMenu__item ${newSubTree ? '' : 'LegacyNavigationMainMenuDesktop--subMenu__item--top'}`}>
              <CoreLink
                className={`LegacyNavigationMainMenuDesktop--subMenu__items__title overlapping-link ${newSubTree ? '' : 'LegacyNavigationMainMenuDesktop--subMenu__items__title--top'}`}
                to={subItemHref}
              >
                <span>
                  {subItemTitle} <div className="icon icon-chevron-right" />
                </span>
              </CoreLink>
            </div>
          </li>
        );
      }

      return (
        <div className="col-12" key={`menu--main--sub-menu-item-${subItemTitle}:${subItemHref}`}>
          <div className={`LegacyNavigationMainMenuDesktop--subMenu__item ${newSubTree ? '' : 'LegacyNavigationMainMenuDesktop--subMenu__item--top'}`}>
            <div
              className={`LegacyNavigationMainMenuDesktop--subMenu__items__title overlapping-link ${newSubTree ? '' : 'LegacyNavigationMainMenuDesktop--subMenu__items__title--top'}`}
            >
              <span className="NavigationMainMenu__subMenuPrefix">
                <span>Kennisaanbod op </span>
                <strong>{subItemTitle.toLowerCase()}</strong>
              </span>
            </div>
          </div>
          <ul
            className={`${
              i === 0
                ? 'LegacyNavigationMainMenuDesktop--subMenu__items__list'
                : 'LegacyNavigationMainMenuDesktop--subMenu__items__list__2'
            }`}
          >
            {subItem.get('subtree').size > 0 && renderMenuRecursively(subItem)}
          </ul>
        </div>
      );
    });
  };

  return (
    <div className="LegacyNavigationMainMenuDesktop--subMenu">
      <Container className="LegacyNavigationMainMenuDesktop--subMenu__container">
        <div className="row">
          <div className="col-12">
            <div className="LegacyNavigationMainMenuDesktop--subMenu__items">
              <div className="row">{renderMenuRecursively()}</div>
            </div>
          </div>
        </div>
      </Container>
      <div className="LegacyNavigationMainMenuDesktop--subMenu__bottom">
        <Container>
          <Button className="Button--ghost">
            {t('menu.close_offers')}
            <div className="icon icon-cross" />
          </Button>
        </Container>
      </div>
    </div>
  );
};

export default NavigationMainMenuSubComponent;
